module.exports = __webpack_public_path__ + "static/img/product_size1.863c12a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/hardProduct/images/phone/product_size1.png
// module id = OPW4
// module chunks = 1